import viacep from "./viacep";

function UserException(message, type) {
    this.message = message;
    this.name = "UserException";
    this.type = type || "invalid"; // "invalid" | "not_found" | "provider_error"
}

const buscaCep = async (cep) => {

    if (cep !== '') {
        let formatCep = cep.replace(/([^\d])+/gim, '');

        if (formatCep.length !== 8) {
            throw new UserException("Informe um CEP com 8 dígitos.", "invalid");
        }

        try {
            const response = await viacep.get(formatCep + "/json");

            if (response.data.cep) {
                return response.data;
            } else {
                throw new UserException("CEP não encontrado. Verifique o número ou preencha o endereço manualmente.", "not_found");
            }
        } catch (error) {
            if (error.name === "UserException") {
                throw error;
            }
            throw new UserException("Não foi possível consultar o CEP. Preencha o endereço manualmente.", "provider_error");
        }

    } else {
        throw new UserException("CEP não pode estar em branco!", "invalid");
    }
}

export default buscaCep;
